export const LEGAL_FOOTNOTES_ID = 'legal-footnotes';
